'use strict';

var Masonry = require('masonry-layout');

function init() {
	var masonryEl = document.getElementsByClassName('msnry');

	if (!masonryEl.length)
		return;

	function initializeMasonry() {
		var msnry = new Masonry('.msnry', {
			percentPosition: true,
			horizontalOrder: true
		});
	}

	window.addEventListener('load', initializeMasonry);
}

module.exports = {
	init: init
}
